import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <>
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-[1200px] mx-auto px-4 py-4">
          <div className="flex items-start justify-between gap-4">
            <div className="flex-shrink-0">
              <Link to="/">
                <img 
                  src="https://www.zeankickoff1.com/images/logo2/logoweb10.jpg" 
                  alt="Zeannkickoff1 Logo" 
                  className="h-20 w-auto"
                />
              </Link>
              <div className="mt-2 text-xs text-gray-600">
                <a href="/contact.html" className="hover:text-blue-600">Contact Us</a>
                <br />
                <span>kickoff.zean@gmail.com</span>
              </div>
            </div>
            
            <div className="flex-1">
              <div className="space-y-2">
                <a href="https://ibit.ly/lalika168" target="_blank" rel="noopener noreferrer">
                  <img 
                    src="https://image.cdend.com/wp-content/uploads/2024/03/728x200-lalikabet168.gif" 
                    alt="Banner" 
                    className="w-full h-auto"
                  />
                </a>
                <a href="https://tinyurl.com/mv7e86ku" target="_blank" rel="noopener noreferrer">
                  <img 
                    src="https://www.zeankickoff1.com/images/Banner2568/FATH_CPD-SPORT_728x180.gif" 
                    alt="Banner" 
                    className="w-full h-auto"
                  />
                </a>
                <a href="https://association-aire.org/" target="_blank" rel="sponsored">
                  <img 
                    src="https://www.zeankickoff1.com/images/Banner2568/Banner--Lottowinner-2026.gif" 
                    alt="Banner" 
                    className="w-full h-auto"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <nav className="bg-gray-800 text-white">
        <div className="max-w-[1200px] mx-auto px-4">
          <div className="hidden md:flex items-center justify-center space-x-1 py-2">
            <Link to="/" className="px-4 py-2 hover:bg-gray-700 rounded transition-colors whitespace-nowrap">
              Home
            </Link>
            <Link to="/news.html" className="px-4 py-2 hover:bg-gray-700 rounded transition-colors whitespace-nowrap">
              News
            </Link>
            <Link to="/libraries/pgss/" className="px-4 py-2 hover:bg-gray-700 rounded transition-colors whitespace-nowrap">
              Articles
            </Link>
            <a href="https://dooball66.net" target="_blank" rel="noopener noreferrer" className="px-4 py-2 hover:bg-gray-700 rounded transition-colors whitespace-nowrap">
              Watch Live
            </a>
            <Link to="/contact.html" className="px-4 py-2 hover:bg-gray-700 rounded transition-colors whitespace-nowrap">
              Contact
            </Link>
          </div>

          <div className="md:hidden flex items-center justify-between py-3">
            <span className="font-semibold">Menu</span>
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="p-2 hover:bg-gray-700 rounded"
              aria-label="Toggle menu"
            >
              <i className={`ri-${mobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
            </button>
          </div>

          {mobileMenuOpen && (
            <div className="md:hidden pb-4 space-y-2">
              <Link to="/" className="block px-4 py-2 hover:bg-gray-700 rounded">
                Home
              </Link>
              <Link to="/news.html" className="block px-4 py-2 hover:bg-gray-700 rounded">
                News
              </Link>
              <Link to="/libraries/pgss/" className="block px-4 py-2 hover:bg-gray-700 rounded">
                Articles
              </Link>
              <a href="https://dooball66.net" target="_blank" rel="noopener noreferrer" className="block px-4 py-2 hover:bg-gray-700 rounded">
                Watch Live
              </a>
              <Link to="/contact.html" className="block px-4 py-2 hover:bg-gray-700 rounded">
                Contact
              </Link>
            </div>
          )}
        </div>
      </nav>
    </>
  );
}
